var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.017,
    height: 21.017,
    viewBox: "0 0 21.017 21.017",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-faq-help-information-mark-question-svgrepo-com",
    transform: "translate(-0.85 -0.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34312",
    "data-name": "Path 34312",
    d: "M12.58,6.866a3.55,3.55,0,0,1,1.871.216,3.478,3.478,0,0,1,1.488,1.145,3.368,3.368,0,0,1,.288,3.58,3.448,3.448,0,0,1-1.289,1.362c-.145.087-.3.168-.43.234l-.1.052a2.209,2.209,0,0,0-.331.2.38.38,0,0,0-.113.125.521.521,0,0,0-.042.24v1a.478.478,0,0,1-.478.478H12.8a.478.478,0,0,1-.478-.478v-1a2.094,2.094,0,0,1,.215-.962,1.962,1.962,0,0,1,.55-.657,3.712,3.712,0,0,1,.574-.358l.144-.075c.116-.06.212-.109.31-.168a1.855,1.855,0,0,0,.694-.732,1.775,1.775,0,0,0-.153-1.89,1.885,1.885,0,0,0-.807-.62,1.957,1.957,0,0,0-1.031-.119,1.926,1.926,0,0,0-.939.421,1.85,1.85,0,0,0-.356.4.6.6,0,0,1-.663.277l-.6-.2a.43.43,0,0,1-.271-.593,3.433,3.433,0,0,1,.875-1.1A3.519,3.519,0,0,1,12.58,6.866Z",
    transform: "translate(-1.818 -1.183)",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34313",
    "data-name": "Path 34313",
    d: "M13.111,19.775a.4.4,0,0,1,.4-.4h.516a.4.4,0,0,1,.4.4v.516a.4.4,0,0,1-.4.4h-.516a.4.4,0,0,1-.4-.4Z",
    transform: "translate(-2.461 -3.734)",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34314",
    "data-name": "Path 34314",
    d: "M11.358,1A10.358,10.358,0,1,0,21.717,11.358,10.358,10.358,0,0,0,11.358,1ZM2.594,11.358a8.765,8.765,0,1,1,8.765,8.765A8.765,8.765,0,0,1,2.594,11.358Z",
    transform: "translate(0 0)",
    stroke: "#fff",
    strokeWidth: 0.3,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.3984b3de4f2edc1e7f92e5c828b821f8.svg";
export { ForwardRef as ReactComponent };